import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../constants";
import AuthFrame from "./v2/AuthFrame";
import { TitleBlock, Field, Input, Note, Actions, PrimaryBtn, InlineLink } from "./v2/pieces";
import { sentence } from "./v2/serverText";

const SEND_FAILED = "We could not send the reset email. Try again.";
export const RESET_LINK_SENT = "If your email exists in our system, you will receive a reset link.";

// Forgot password, on the V2 auth frame: mails a link to set a new
// password. The same link confirms the email of an account opened with a
// mobile code, so it is also how the email's owner claims that account.
const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const toLogin = () => navigate("/login");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    // Accounts are stored lower-cased, as log in and sign-up send them.
    const address = email.trim().toLowerCase();
    if (!address) {
      setError("Enter your email.");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/api/users/password-reset/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: address }),
      });
      let data = {};
      try { data = await response.json(); } catch { data = {}; }
      if (response.ok) setMessage(RESET_LINK_SENT);
      else setError(sentence(data?.message) || sentence(data?.detail) || sentence(data?.error) || SEND_FAILED);
    } catch {
      setError(SEND_FAILED);
    }
    setLoading(false);
  };

  return (
    <AuthFrame title="Reset your password" onBack={toLogin}>
      <form className="contents" onSubmit={handleSubmit}>
        <TitleBlock eyebrow="Password" title="Forgot your password?" sub="Enter the email on your account and we will send you a link to set a new password." />
        <Field label="Email">
          <Input type="email" autoComplete="email" placeholder="you@email.com" value={email} onChange={(e) => setEmail(e.target.value)} aria-label="Email" />
        </Field>
        {message && <Note tone="success">{message}</Note>}
        {error && <Note tone="critical">{error}</Note>}
        <Actions>
          <PrimaryBtn type="submit" loading={loading}>Send reset link</PrimaryBtn>
          <InlineLink text="Remembered it?" label="Log in" onClick={toLogin} />
        </Actions>
      </form>
    </AuthFrame>
  );
};

export default ForgotPassword;
